import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Constants from "../../AppConstants/Constants";
import Layout from "../../Layouts/LayoutMain";
import AlreadyApprovedModal from "../../Components/Modals/AlreadyApprovedModal";
import { updateAlreadyApprovedModalState } from "../../Store/Modals/Actions";
import { getTopicDetails } from "../../Store/Topics/Actions";
import ContentManagement from "../../Components/Common/TopicTemplate2";

class PaymentOptions extends Component {
    constructor(props) {
        super(props);

        this.onGetApprovedClick = this.onGetApprovedClick.bind(this);
        this.onAlreadyApprovedClick = this.onAlreadyApprovedClick.bind(this);
    }

    componentWillMount() {
        const { getTopicDetails, topicDetails, config: { TOPICS: { PAYMENT_OPTIONS_TOPIC_ID } }, i18n } = this.props;

        if (!topicDetails[PAYMENT_OPTIONS_TOPIC_ID] || topicDetails[PAYMENT_OPTIONS_TOPIC_ID].locale !== i18n.locale) {
            getTopicDetails(PAYMENT_OPTIONS_TOPIC_ID);
        }
    }

    componentDidMount() {
        const { topicDetails, config: { TOPICS: { PAYMENT_OPTIONS_TOPIC_ID } } } = this.props;

        // This will create event handlers on subsequent visits after the first one
        if (topicDetails[PAYMENT_OPTIONS_TOPIC_ID]) {
            $(".get-approved").click(this.onGetApprovedClick);

            $("#already-approved").click(this.onAlreadyApprovedClick);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { topicDetails: prevTopicDetails } = prevProps;
        const { topicDetails, config: { TOPICS: { PAYMENT_OPTIONS_TOPIC_ID } } } = this.props;

        // This will create event handlers the first time
        if (prevTopicDetails[PAYMENT_OPTIONS_TOPIC_ID] !== topicDetails[PAYMENT_OPTIONS_TOPIC_ID]) {
            $(".get-approved").click(this.onGetApprovedClick);

            $("#already-approved").click(this.onAlreadyApprovedClick);
        }
    }

    onGetApprovedClick(e) {
        e.preventDefault();

        const { history } = this.props;

        history.push(Constants.ENDPOINTS.LEASE_APPLICATION);
    }

    onAlreadyApprovedClick() {
        const { updateAlreadyApprovedModalState } = this.props;

        updateAlreadyApprovedModalState(true);
    }

    render() {
        const { isAuthenticated, topicDetails, config: { TOPICS: { PAYMENT_OPTIONS_TOPIC_ID } } } = this.props;

        return (
            <Layout isAuthenticated={isAuthenticated}>
                {topicDetails[PAYMENT_OPTIONS_TOPIC_ID] &&
                <ContentManagement
                    title={topicDetails[PAYMENT_OPTIONS_TOPIC_ID].title}
                    body={topicDetails[PAYMENT_OPTIONS_TOPIC_ID].body}
                />
                }
                <AlreadyApprovedModal/>
            </Layout>
        );
    }
}

PaymentOptions.propTypes = {
    updateAlreadyApprovedModalState: PropTypes.func,
    getTopicDetails: PropTypes.func,
    i18n: PropTypes.object,
    userInfo: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    topicDetails: PropTypes.object,
    config: PropTypes.object,
    history: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        topicDetails: state.topicDetails,
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateAlreadyApprovedModalState: updateAlreadyApprovedModalState,
        getTopicDetails: getTopicDetails
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentOptions));